import { useRef } from "react";
import { useScrollLock, useIsomorphicLayoutEffect } from "usehooks-ts";
import { getScrollbarWidth } from "@/utils";

export const useLockBodyScroll = () => {
  const lockTarget = useRef<HTMLElement>(null!);
  const styleTarget = useRef<HTMLElement>(null!);
  const originalStyle = useRef<OriginalStyle | null>(null);

  const lock = () => {
    _lock();
    const { paddingRight } = styleTarget.current.style;
    originalStyle.current = { paddingRight };
    // Prevent width reflow
    styleTarget.current.style.paddingRight = `${scrollbarWidth}px`;
  };

  const unlock = () => {
    _unlock();
    if (styleTarget.current && originalStyle.current) {
      styleTarget.current.style.paddingRight =
        originalStyle.current.paddingRight;
    }
    lockTarget.current.removeAttribute("style");
  };

  const { lock: _lock, unlock: _unlock } = useScrollLock({
    autoLock: false,
    lockTarget: lockTarget.current,
    widthReflow: false,
  });

  useIsomorphicLayoutEffect(() => {
    unlock();
    return () => {
      unlock();
    };
  }, []);

  if (typeof document === "undefined")
    return { lock: () => {}, unlock: () => {} };
  lockTarget.current = document.documentElement;
  styleTarget.current = document.body;
  const scrollbarWidth = getScrollbarWidth();

  return { lock, unlock };
};

type OriginalStyle = {
  paddingRight: CSSStyleDeclaration["paddingRight"];
};
